//vuex
import {mapState, mapGetters, mapMutations} from 'vuex'
//axios
import axios from 'axios'
import apiConfig from 'common/js/api_config'

// 定义一个混入对象
export default {
  data() {
    return {
      //===========【工程新版筛选】===========
      filterMenuList: [
        {
          name: '部门分类',
          value: 1,
          style: 'dept',
          dataKey: 'filterDeptList',
          idKey: 'deptId'
        },
        {
          name: '主题分类',
          value: 2,
          style: 'theme',
          dataKey: 'filterThemeList',
          idKey: 'dictLabel'
        },
      ],
      currSelectFilterMenu: 1,
      currSelectFilterValue: null,
      
      showOptionList: [],
      filterDeptList: [],
      filterThemeList: [],
      
      showAllFilterOptions: false,
      
      stateList: [
        {
          name: "进行中",
          field: 'runingNum',
          icon: 'icon-jinhangzhong',
          id: 0,
        },
        {
          name: "已完成",
          field: 'finishNum',
          icon: 'icon-yiwancheng',
          id: 1,
        },
        {
          name: "我发起的",
          field: 'myApplyNum',
          icon: 'icon-wofaqide',
          id: 2,
        },
      ],
      filterStateField: null
    }
  },
  created() {
  },
  computed: {},
  methods: {
    async fetchFilterDeptList() {
      let resp = await axios.post(apiConfig.REQUEST_URL + '/shall/front_selectDeptSortList?terminal=0&dictValue=' + this.currentTabId)
      apiConfig.resultHandle(resp, (result) => {
        result.data.forEach((item) => {
          if (item.deptName.indexOf('（') === -1) {
            return
          }
          let start = item.deptName.indexOf('（')
          let end = item.deptName.indexOf('）') + 1
          item.deptName = item.deptName.replace(item.deptName.slice(start, end), '')
        })
        this.filterDeptList = result.data
      })
    },
    async fetchFilterThemeList() {
      let resp = await axios.post(apiConfig.REQUEST_URL + '/shall/front_selectSubjectSortList?terminal=0&dictValue=' + this.currentTabId)
      apiConfig.resultHandle(resp, (result) => {
        this.filterThemeList = result.data
      })
    },
    getFilterMenuInfoByValue(value) {
      for (let i = 0; i < this.filterMenuList.length; i++) {
        if (this.filterMenuList[i].value === value) {
          return this.filterMenuList[i]
        }
      }
    },
    setShowMenuList() {
      let currMenuInfo = this.getFilterMenuInfoByValue(this.currSelectFilterMenu)
      if (currMenuInfo) {
        this.showOptionList = this[currMenuInfo.dataKey]
      }
      
      
    },
    changeFilterMenuSelect(item) {
      this.currSelectFilterMenu = item.value
      this.setShowMenuList()
      this.currSelectFilterValue = null
      this.fetchFilterDeptList()
      this.fetchFilterThemeList()
      this.initServiceList()
    },
    filterAction(item) {
      if (item.deptId === this.currSelectFilterValue || item.dictLabel === this.currSelectFilterValue) {
        this.currSelectFilterValue = null
        this.initServiceList()
        return
      }
      let targetMenuInfo = this.getFilterMenuInfoByValue(this.currSelectFilterMenu)
      if (targetMenuInfo) this.currSelectFilterValue = item[targetMenuInfo.idKey]
      this.initServiceList()
      console.log(document.getElementById('main'))
      window.scroll({
        top: document.getElementById('main').offsetTop
      })
    },
    showAllAction() {
      this.showAllFilterOptions = !this.showAllFilterOptions
    },
    selectState(id) {
    
    },
    resetServiceList() {
      this.currSelectFilterValue = null
      this.currentTabId = null
      this.currType = null
      this.orgid = null
      this.initServiceList()
    }
  },
  mounted() {
    this.setShowMenuList()
    //this.fetchFilterDeptList()
    //this.fetchFilterThemeList()
  }
}



// WEBPACK FOOTER //
// ./src/pages/mixin/filter.js